/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * @sentinel/hooks
 * react-query hooks for interacting with sentinel
 * OpenAPI spec version: 1.0
 */ import { useMutation, useQuery } from "@tanstack/react-query";
import { faker } from "@faker-js/faker";
import { HttpResponse, delay, http } from "msw";
import { client } from "./client";
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserInviteRequestRole = {
    manager: 'manager',
    agent: 'agent',
    onboardingAgent: 'onboardingAgent',
    onboardingManager: 'onboardingManager'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenReqDtoGrantType = {
    authorization_code: 'authorization_code',
    client_credentials: 'client_credentials',
    refresh_token: 'refresh_token'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SponsorRegistrationProgram = {
    register: 'register',
    exempt: 'exempt'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RevokeReqDtoTokenTypeHint = {
    access_token: 'access_token',
    refresh_token: 'refresh_token'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RevokeConsentDtoInitiator = {
    INDIVIDUAL: 'INDIVIDUAL',
    DATA_RECIPIENT: 'DATA_RECIPIENT',
    DATA_PROVIDER: 'DATA_PROVIDER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegistrationStateDtoProgram = {
    register: 'register',
    exempt: 'exempt'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReasonBodyDtoExemptionReason = {
    '401a': '401a',
    '403a': '403a',
    '403b': '403b',
    '408k': '408k',
    '408p': '408p',
    '457b': '457b'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostVerifyReqDtoEntityType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor',
    state_saver: 'state_saver',
    giftor: 'giftor',
    tpa: 'tpa'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostUserRolesReqBodyDtoEntityType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor',
    state_saver: 'state_saver',
    giftor: 'giftor',
    tpa: 'tpa'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostLoginTempBodyDtoEntityType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor',
    state_saver: 'state_saver',
    giftor: 'giftor',
    tpa: 'tpa'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEntityLoginBodyDtoEntityType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor',
    state_saver: 'state_saver',
    giftor: 'giftor',
    tpa: 'tpa'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonaSessionDtoType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor',
    state_saver: 'state_saver',
    giftor: 'giftor',
    tpa: 'tpa'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchRegistrationEntityDtoEntity = {
    advisor: 'advisor',
    accessCode: 'accessCode',
    participant: 'participant',
    sponsor: 'sponsor'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImpersonationAuthReqDtoResponseType = {
    code: 'code',
    token: 'token'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserRolesResDtoEntityType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor',
    state_saver: 'state_saver',
    giftor: 'giftor',
    tpa: 'tpa'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityResourceEntityType = {
    Account: 'Account',
    Advisor: 'Advisor',
    Alert: 'Alert',
    Bank_Account: 'Bank Account',
    Firm: 'Firm',
    Firm_Rep: 'Firm Rep',
    Firm_Lineup: 'Firm Lineup',
    giftor: 'giftor',
    Investment_Program: 'Investment Program',
    Mailer_Letter: 'Mailer Letter',
    Model: 'Model',
    Participant: 'Participant',
    Participant_Bank_Account: 'Participant Bank Account',
    ParticipantBeacon: 'ParticipantBeacon',
    ParticipantVer: 'ParticipantVer',
    Participant_Plaid_Integrated_Retirement_Funding_Account: 'Participant Plaid Integrated Retirement Funding Account',
    PooledPlan: 'PooledPlan',
    ProposalPlan: 'ProposalPlan',
    psa: 'psa',
    Risk_Series: 'Risk Series',
    Sponsor: 'Sponsor',
    Sponsor_Bank_Account: 'Sponsor Bank Account',
    SponsorPlan: 'SponsorPlan',
    state_saver: 'state_saver',
    Target_Date_Series: 'Target Date Series',
    user: 'user',
    Withdrawal_Rollover_Delivery: 'Withdrawal Rollover Delivery'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteUserRolesDtoEntityType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor',
    state_saver: 'state_saver',
    giftor: 'giftor',
    tpa: 'tpa'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactBodyDtoEntity = {
    advisor: 'advisor',
    accessCode: 'accessCode',
    participant: 'participant',
    sponsor: 'sponsor'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConsentPartyEntityType = {
    DATA_RECIPIENT: 'DATA_RECIPIENT',
    DATA_PROVIDER: 'DATA_PROVIDER'
};
export const postSponsorExemptionConfirmation = (confirmBodyDto)=>{
    return client({
        url: `/auth/api/exempt/confirmation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: confirmBodyDto
    });
};
export const getPostSponsorExemptionConfirmationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorExemptionConfirmation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorExemptionConfirmation = (options)=>{
    const mutationOptions = getPostSponsorExemptionConfirmationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorExemptionReason = (reasonBodyDto)=>{
    return client({
        url: `/auth/api/exempt/reason`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: reasonBodyDto
    });
};
export const getPostSponsorExemptionReasonMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorExemptionReason(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorExemptionReason = (options)=>{
    const mutationOptions = getPostSponsorExemptionReasonMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postOnboardingSponsorExemptionConfirmation = (confirmBodyDto)=>{
    return client({
        url: `/auth/api/onboarding/exempt/confirmation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: confirmBodyDto
    });
};
export const getPostOnboardingSponsorExemptionConfirmationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postOnboardingSponsorExemptionConfirmation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostOnboardingSponsorExemptionConfirmation = (options)=>{
    const mutationOptions = getPostOnboardingSponsorExemptionConfirmationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postOnboardingSponsorExemptionReason = (reasonBodyDto)=>{
    return client({
        url: `/auth/api/onboarding/exempt/reason`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: reasonBodyDto
    });
};
export const getPostOnboardingSponsorExemptionReasonMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postOnboardingSponsorExemptionReason(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostOnboardingSponsorExemptionReason = (options)=>{
    const mutationOptions = getPostOnboardingSponsorExemptionReasonMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantAddressOptions = (signal)=>{
    return client({
        url: `/auth/api/register/address/options`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantAddressOptionsQueryKey = ()=>{
    return [
        `/auth/api/register/address/options`
    ];
};
export const getGetParticipantAddressOptionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAddressOptionsQueryKey();
    const queryFn = ({ signal })=>getParticipantAddressOptions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetParticipantAddressOptions(options) {
    const queryOptions = getGetParticipantAddressOptionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const postParticipantAddressVerify = (participantVerifyAddressBody)=>{
    return client({
        url: `/auth/api/register/address/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantVerifyAddressBody
    });
};
export const getPostParticipantAddressVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantAddressVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantAddressVerify = (options)=>{
    const mutationOptions = getPostParticipantAddressVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postAdvisorConnect = (connectBodyDto)=>{
    return client({
        url: `/auth/api/register/advisor/connect`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: connectBodyDto
    });
};
export const getPostAdvisorConnectMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorConnect(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorConnect = (options)=>{
    const mutationOptions = getPostAdvisorConnectMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postAdvisorPassword = (passwordBodyDto)=>{
    return client({
        url: `/auth/api/register/advisor/password`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: passwordBodyDto
    });
};
export const getPostAdvisorPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorPassword = (options)=>{
    const mutationOptions = getPostAdvisorPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postAdvisorVerify = (verifyBodyDto)=>{
    return client({
        url: `/auth/api/register/advisor/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: verifyBodyDto
    });
};
export const getPostAdvisorVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorVerify = (options)=>{
    const mutationOptions = getPostAdvisorVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantCompanyOptions = (signal)=>{
    return client({
        url: `/auth/api/register/company/options`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantCompanyOptionsQueryKey = ()=>{
    return [
        `/auth/api/register/company/options`
    ];
};
export const getGetParticipantCompanyOptionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantCompanyOptionsQueryKey();
    const queryFn = ({ signal })=>getParticipantCompanyOptions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetParticipantCompanyOptions(options) {
    const queryOptions = getGetParticipantCompanyOptionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const postParticipantCompanyVerify = (participantVerifyCompanyBody)=>{
    return client({
        url: `/auth/api/register/company/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantVerifyCompanyBody
    });
};
export const getPostParticipantCompanyVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantCompanyVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantCompanyVerify = (options)=>{
    const mutationOptions = getPostParticipantCompanyVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postParticipantConnectVerify = (connectVerifyBody)=>{
    return client({
        url: `/auth/api/register/connect/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: connectVerifyBody
    });
};
export const getPostParticipantConnectVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantConnectVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantConnectVerify = (options)=>{
    const mutationOptions = getPostParticipantConnectVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const patchParticipantContact = (contactDto)=>{
    return client({
        url: `/auth/api/register/contact`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: contactDto
    });
};
export const getPatchParticipantContactMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchParticipantContact(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantContact = (options)=>{
    const mutationOptions = getPatchParticipantContactMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRegistrationContact = (contactBodyDto)=>{
    return client({
        url: `/auth/api/register/contact`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: contactBodyDto
    });
};
export const getPostRegistrationContactMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRegistrationContact(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRegistrationContact = (options)=>{
    const mutationOptions = getPostRegistrationContactMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorVerify = (sponsorVerifyBody)=>{
    return client({
        url: `/auth/api/register/employer`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorVerifyBody
    });
};
export const getPostSponsorVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorVerify = (options)=>{
    const mutationOptions = getPostSponsorVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorAccessCodeRequest = (sponsorAccessCodeRequestBody)=>{
    return client({
        url: `/auth/api/register/employer/access-code-request`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorAccessCodeRequestBody
    });
};
export const getPostSponsorAccessCodeRequestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorAccessCodeRequest(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorAccessCodeRequest = (options)=>{
    const mutationOptions = getPostSponsorAccessCodeRequestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorConnect = (sponsorContactBody)=>{
    return client({
        url: `/auth/api/register/employer/connect`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorContactBody
    });
};
export const getPostSponsorConnectMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorConnect(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorConnect = (options)=>{
    const mutationOptions = getPostSponsorConnectMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorPassword = (sponsorPasswordBody)=>{
    return client({
        url: `/auth/api/register/employer/password`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorPasswordBody
    });
};
export const getPostSponsorPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorPassword = (options)=>{
    const mutationOptions = getPostSponsorPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postParticipantPassword = (passwordDto)=>{
    return client({
        url: `/auth/api/register/password`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: passwordDto
    });
};
export const getPostParticipantPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantPassword = (options)=>{
    const mutationOptions = getPostParticipantPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postParticipantVerify = (participantVerifyBody)=>{
    return client({
        url: `/auth/api/register/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantVerifyBody
    });
};
export const getPostParticipantVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantVerify = (options)=>{
    const mutationOptions = getPostParticipantVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRegistrationState = (signal)=>{
    return client({
        url: `/auth/api/registration/state`,
        method: 'GET',
        signal
    });
};
export const getGetRegistrationStateQueryKey = ()=>{
    return [
        `/auth/api/registration/state`
    ];
};
export const getGetRegistrationStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRegistrationStateQueryKey();
    const queryFn = ({ signal })=>getRegistrationState(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetRegistrationState(options) {
    const queryOptions = getGetRegistrationStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const patchRegistrationState = (patchRegistrationEntityDto)=>{
    return client({
        url: `/auth/api/registration/state`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchRegistrationEntityDto
    });
};
export const getPatchRegistrationStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchRegistrationState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchRegistrationState = (options)=>{
    const mutationOptions = getPatchRegistrationStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postBiometricLogin = (postBiometricLoginBodyDto)=>{
    return client({
        url: `/auth/api/v1/bio-login`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postBiometricLoginBodyDto
    });
};
export const getPostBiometricLoginMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postBiometricLogin(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostBiometricLogin = (options)=>{
    const mutationOptions = getPostBiometricLoginMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPayrollSetup = (postPayrollSetupBodyDto)=>{
    return client({
        url: `/auth/api/v1/connect`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPayrollSetupBodyDto
    });
};
export const getPostPayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPayrollSetup(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPayrollSetup = (options)=>{
    const mutationOptions = getPostPayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const disableDevice = ()=>{
    return client({
        url: `/auth/api/v1/device`,
        method: 'DELETE'
    });
};
export const getDisableDeviceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return disableDevice();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDisableDevice = (options)=>{
    const mutationOptions = getDisableDeviceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const listDevices = (signal)=>{
    return client({
        url: `/auth/api/v1/device`,
        method: 'GET',
        signal
    });
};
export const getListDevicesQueryKey = ()=>{
    return [
        `/auth/api/v1/device`
    ];
};
export const getListDevicesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListDevicesQueryKey();
    const queryFn = ({ signal })=>listDevices(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useListDevices(options) {
    const queryOptions = getListDevicesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const registerDevice = ()=>{
    return client({
        url: `/auth/api/v1/device/register`,
        method: 'POST'
    });
};
export const getRegisterDeviceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return registerDevice();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useRegisterDevice = (options)=>{
    const mutationOptions = getRegisterDeviceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postGiftorUserSessionStart = (postUserSessionStartBodyDto)=>{
    return client({
        url: `/auth/api/v1/giftor/user/session/start`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postUserSessionStartBodyDto
    });
};
export const getPostGiftorUserSessionStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postGiftorUserSessionStart(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostGiftorUserSessionStart = (options)=>{
    const mutationOptions = getPostGiftorUserSessionStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postLogin = (postLoginBodyDto)=>{
    return client({
        url: `/auth/api/v1/login`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postLoginBodyDto
    });
};
export const getPostLoginMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postLogin(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostLogin = (options)=>{
    const mutationOptions = getPostLoginMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postEntityLogin = (postEntityLoginBodyDto)=>{
    return client({
        url: `/auth/api/v1/login/entity`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postEntityLoginBodyDto
    });
};
export const getPostEntityLoginMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEntityLogin(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEntityLogin = (options)=>{
    const mutationOptions = getPostEntityLoginMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getLoginLog = (params, signal)=>{
    return client({
        url: `/auth/api/v1/login/logs`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetLoginLogQueryKey = (params)=>{
    return [
        `/auth/api/v1/login/logs`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetLoginLogQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLoginLogQueryKey(params);
    const queryFn = ({ signal })=>getLoginLog(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetLoginLog(params, options) {
    const queryOptions = getGetLoginLogQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getMfaMethods = (signal)=>{
    return client({
        url: `/auth/api/v1/mfa/entries`,
        method: 'GET',
        signal
    });
};
export const getGetMfaMethodsQueryKey = ()=>{
    return [
        `/auth/api/v1/mfa/entries`
    ];
};
export const getGetMfaMethodsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMfaMethodsQueryKey();
    const queryFn = ({ signal })=>getMfaMethods(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetMfaMethods(options) {
    const queryOptions = getGetMfaMethodsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const deleteMfaEntry = (mfaEntryId)=>{
    return client({
        url: `/auth/api/v1/mfa/entries/${mfaEntryId}`,
        method: 'DELETE'
    });
};
export const getDeleteMfaEntryMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { mfaEntryId } = props ?? {};
        return deleteMfaEntry(mfaEntryId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteMfaEntry = (options)=>{
    const mutationOptions = getDeleteMfaEntryMutationOptions(options);
    return useMutation(mutationOptions);
};
export const patchMfaIsPrimary = (mfaEntryId)=>{
    return client({
        url: `/auth/api/v1/mfa/is-primary/${mfaEntryId}`,
        method: 'PATCH'
    });
};
export const getPatchMfaIsPrimaryMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { mfaEntryId } = props ?? {};
        return patchMfaIsPrimary(mfaEntryId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchMfaIsPrimary = (options)=>{
    const mutationOptions = getPatchMfaIsPrimaryMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getQrCode = (signal)=>{
    return client({
        url: `/auth/api/v1/mfa/qr-code`,
        method: 'GET',
        signal
    });
};
export const getGetQrCodeQueryKey = ()=>{
    return [
        `/auth/api/v1/mfa/qr-code`
    ];
};
export const getGetQrCodeQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetQrCodeQueryKey();
    const queryFn = ({ signal })=>getQrCode(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetQrCode(options) {
    const queryOptions = getGetQrCodeQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const postMfaSend = (postMfaSendBodyDto)=>{
    return client({
        url: `/auth/api/v1/mfa/send`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMfaSendBodyDto
    });
};
export const getPostMfaSendMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMfaSend(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMfaSend = (options)=>{
    const mutationOptions = getPostMfaSendMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postMfaSetup = (postMfaSetupBodyDto)=>{
    return client({
        url: `/auth/api/v1/mfa/setup`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMfaSetupBodyDto
    });
};
export const getPostMfaSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMfaSetup(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMfaSetup = (options)=>{
    const mutationOptions = getPostMfaSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postMfaSetupVerify = (postMfaSetupVerifyBodyDto)=>{
    return client({
        url: `/auth/api/v1/mfa/setup/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMfaSetupVerifyBodyDto
    });
};
export const getPostMfaSetupVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMfaSetupVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMfaSetupVerify = (options)=>{
    const mutationOptions = getPostMfaSetupVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postMfaVerify = (postMfaVerifyBodyDto)=>{
    return client({
        url: `/auth/api/v1/mfa/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMfaVerifyBodyDto
    });
};
export const getPostMfaVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMfaVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMfaVerify = (options)=>{
    const mutationOptions = getPostMfaVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getJwks = (signal)=>{
    return client({
        url: `/auth/api/v1/oidc/.well-known/jwks.json`,
        method: 'GET',
        signal
    });
};
export const getGetJwksQueryKey = ()=>{
    return [
        `/auth/api/v1/oidc/.well-known/jwks.json`
    ];
};
export const getGetJwksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetJwksQueryKey();
    const queryFn = ({ signal })=>getJwks(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetJwks(options) {
    const queryOptions = getGetJwksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getDiscovery = (signal)=>{
    return client({
        url: `/auth/api/v1/oidc/.well-known/openid-configuration`,
        method: 'GET',
        signal
    });
};
export const getGetDiscoveryQueryKey = ()=>{
    return [
        `/auth/api/v1/oidc/.well-known/openid-configuration`
    ];
};
export const getGetDiscoveryQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDiscoveryQueryKey();
    const queryFn = ({ signal })=>getDiscovery(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetDiscovery(options) {
    const queryOptions = getGetDiscoveryQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const postAuthImpersonation = (impersonationAuthReqDto)=>{
    return client({
        url: `/auth/api/v1/oidc/auth/impersonation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: impersonationAuthReqDto
    });
};
export const getPostAuthImpersonationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAuthImpersonation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAuthImpersonation = (options)=>{
    const mutationOptions = getPostAuthImpersonationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postIntrospect = (introspectReqDto)=>{
    return client({
        url: `/auth/api/v1/oidc/introspect`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: introspectReqDto
    });
};
export const getPostIntrospectMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postIntrospect(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIntrospect = (options)=>{
    const mutationOptions = getPostIntrospectMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPushedAuthorizationRequest = (pushedAuthorizationReqDto)=>{
    return client({
        url: `/auth/api/v1/oidc/par`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: pushedAuthorizationReqDto
    });
};
export const getPostPushedAuthorizationRequestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPushedAuthorizationRequest(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPushedAuthorizationRequest = (options)=>{
    const mutationOptions = getPostPushedAuthorizationRequestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRevoke = (revokeReqDto)=>{
    return client({
        url: `/auth/api/v1/oidc/revoke`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: revokeReqDto
    });
};
export const getPostRevokeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRevoke(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRevoke = (options)=>{
    const mutationOptions = getPostRevokeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postToken = (tokenReqDto)=>{
    return client({
        url: `/auth/api/v1/oidc/token`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: tokenReqDto
    });
};
export const getPostTokenMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postToken(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostToken = (options)=>{
    const mutationOptions = getPostTokenMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * @summary User Info Endpoint
 */ export const getUserinfo = (signal)=>{
    return client({
        url: `/auth/api/v1/oidc/userinfo`,
        method: 'GET',
        signal
    });
};
export const getGetUserinfoQueryKey = ()=>{
    return [
        `/auth/api/v1/oidc/userinfo`
    ];
};
export const getGetUserinfoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUserinfoQueryKey();
    const queryFn = ({ signal })=>getUserinfo(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
/**
 * @summary User Info Endpoint
 */ export function useGetUserinfo(options) {
    const queryOptions = getGetUserinfoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const postForgotPassword = (postForgotPasswordBodyDto)=>{
    return client({
        url: `/auth/api/v1/password/forgot`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postForgotPasswordBodyDto
    });
};
export const getPostForgotPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postForgotPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostForgotPassword = (options)=>{
    const mutationOptions = getPostForgotPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putResetPassword = (putResetPasswordBodyDto)=>{
    return client({
        url: `/auth/api/v1/password/reset`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putResetPasswordBodyDto
    });
};
export const getPutResetPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putResetPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutResetPassword = (options)=>{
    const mutationOptions = getPutResetPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postVerifyPassword = (putResetPasswordBodyDto)=>{
    return client({
        url: `/auth/api/v1/password/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putResetPasswordBodyDto
    });
};
export const getPostVerifyPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postVerifyPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostVerifyPassword = (options)=>{
    const mutationOptions = getPostVerifyPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPersonas = (params, signal)=>{
    return client({
        url: `/auth/api/v1/personas`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPersonasQueryKey = (params)=>{
    return [
        `/auth/api/v1/personas`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPersonasQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPersonasQueryKey(params);
    const queryFn = ({ signal })=>getPersonas(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetPersonas(params, options) {
    const queryOptions = getGetPersonasQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getOnpaySso = (signal)=>{
    return client({
        url: `/auth/api/v1/sso/onpay`,
        method: 'GET',
        signal
    });
};
export const getGetOnpaySsoQueryKey = ()=>{
    return [
        `/auth/api/v1/sso/onpay`
    ];
};
export const getGetOnpaySsoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnpaySsoQueryKey();
    const queryFn = ({ signal })=>getOnpaySso(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetOnpaySso(options) {
    const queryOptions = getGetOnpaySsoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getOnpaySsoCallback = (signal)=>{
    return client({
        url: `/auth/api/v1/sso/onpay/callback`,
        method: 'GET',
        signal
    });
};
export const getGetOnpaySsoCallbackQueryKey = ()=>{
    return [
        `/auth/api/v1/sso/onpay/callback`
    ];
};
export const getGetOnpaySsoCallbackQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnpaySsoCallbackQueryKey();
    const queryFn = ({ signal })=>getOnpaySsoCallback(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetOnpaySsoCallback(options) {
    const queryOptions = getGetOnpaySsoCallbackQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getOnpaySsoInit = (signal)=>{
    return client({
        url: `/auth/api/v1/sso/onpay/init`,
        method: 'GET',
        signal
    });
};
export const getGetOnpaySsoInitQueryKey = ()=>{
    return [
        `/auth/api/v1/sso/onpay/init`
    ];
};
export const getGetOnpaySsoInitQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnpaySsoInitQueryKey();
    const queryFn = ({ signal })=>getOnpaySsoInit(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetOnpaySsoInit(options) {
    const queryOptions = getGetOnpaySsoInitQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getStateSaverUserSessionRefresh = (params, signal)=>{
    return client({
        url: `/auth/api/v1/state-saver/user/session/refresh`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetStateSaverUserSessionRefreshQueryKey = (params)=>{
    return [
        `/auth/api/v1/state-saver/user/session/refresh`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetStateSaverUserSessionRefreshQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStateSaverUserSessionRefreshQueryKey(params);
    const queryFn = ({ signal })=>getStateSaverUserSessionRefresh(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetStateSaverUserSessionRefresh(params, options) {
    const queryOptions = getGetStateSaverUserSessionRefreshQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const postStateSaverUserSessionRefresh = ()=>{
    return client({
        url: `/auth/api/v1/state-saver/user/session/refresh`,
        method: 'POST'
    });
};
export const getPostStateSaverUserSessionRefreshMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postStateSaverUserSessionRefresh();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostStateSaverUserSessionRefresh = (options)=>{
    const mutationOptions = getPostStateSaverUserSessionRefreshMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getStateSaverUserSessionStart = (params, signal)=>{
    return client({
        url: `/auth/api/v1/state-saver/user/session/start`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetStateSaverUserSessionStartQueryKey = (params)=>{
    return [
        `/auth/api/v1/state-saver/user/session/start`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetStateSaverUserSessionStartQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStateSaverUserSessionStartQueryKey(params);
    const queryFn = ({ signal })=>getStateSaverUserSessionStart(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetStateSaverUserSessionStart(params, options) {
    const queryOptions = getGetStateSaverUserSessionStartQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const postStateSaverUserSessionStart = (postStateSaverUserSessionStartBodyDto)=>{
    return client({
        url: `/auth/api/v1/state-saver/user/session/start`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postStateSaverUserSessionStartBodyDto
    });
};
export const getPostStateSaverUserSessionStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postStateSaverUserSessionStart(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostStateSaverUserSessionStart = (options)=>{
    const mutationOptions = getPostStateSaverUserSessionStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getStatus = (signal)=>{
    return client({
        url: `/auth/api/v1/status`,
        method: 'GET',
        signal
    });
};
export const getGetStatusQueryKey = ()=>{
    return [
        `/auth/api/v1/status`
    ];
};
export const getGetStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStatusQueryKey();
    const queryFn = ({ signal })=>getStatus(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetStatus(options) {
    const queryOptions = getGetStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getPasswordStatus = (signal)=>{
    return client({
        url: `/auth/api/v1/status/password`,
        method: 'GET',
        signal
    });
};
export const getGetPasswordStatusQueryKey = ()=>{
    return [
        `/auth/api/v1/status/password`
    ];
};
export const getGetPasswordStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPasswordStatusQueryKey();
    const queryFn = ({ signal })=>getPasswordStatus(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetPasswordStatus(options) {
    const queryOptions = getGetPasswordStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getEntityStatus = (entityType, signal)=>{
    return client({
        url: `/auth/api/v1/status/${entityType}`,
        method: 'GET',
        signal
    });
};
export const getGetEntityStatusQueryKey = (entityType)=>{
    return [
        `/auth/api/v1/status/${entityType}`
    ];
};
export const getGetEntityStatusQueryOptions = (entityType, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEntityStatusQueryKey(entityType);
    const queryFn = ({ signal })=>getEntityStatus(entityType, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!entityType,
        ...queryOptions
    };
};
export function useGetEntityStatus(entityType, options) {
    const queryOptions = getGetEntityStatusQueryOptions(entityType, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const patchUserEmail = (patchUserEmailBody)=>{
    return client({
        url: `/auth/api/v1/user/email`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchUserEmailBody
    });
};
export const getPatchUserEmailMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchUserEmail(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchUserEmail = (options)=>{
    const mutationOptions = getPatchUserEmailMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postUserEmailChange = (postUserEmailChangeBody)=>{
    return client({
        url: `/auth/api/v1/user/email`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postUserEmailChangeBody
    });
};
export const getPostUserEmailChangeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postUserEmailChange(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostUserEmailChange = (options)=>{
    const mutationOptions = getPostUserEmailChangeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getUserPreferences = (params, signal)=>{
    return client({
        url: `/auth/api/v1/user/preferences`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetUserPreferencesQueryKey = (params)=>{
    return [
        `/auth/api/v1/user/preferences`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetUserPreferencesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUserPreferencesQueryKey(params);
    const queryFn = ({ signal })=>getUserPreferences(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetUserPreferences(params, options) {
    const queryOptions = getGetUserPreferencesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const patchUserPreferences = (userPreferencesDto)=>{
    return client({
        url: `/auth/api/v1/user/preferences`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: userPreferencesDto
    });
};
export const getPatchUserPreferencesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchUserPreferences(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchUserPreferences = (options)=>{
    const mutationOptions = getPatchUserPreferencesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSessionInfo = (type, signal)=>{
    return client({
        url: `/auth/api/v1/user/session/${type}`,
        method: 'GET',
        signal
    });
};
export const getGetSessionInfoQueryKey = (type)=>{
    return [
        `/auth/api/v1/user/session/${type}`
    ];
};
export const getGetSessionInfoQueryOptions = (type, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSessionInfoQueryKey(type);
    const queryFn = ({ signal })=>getSessionInfo(type, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!type,
        ...queryOptions
    };
};
export function useGetSessionInfo(type, options) {
    const queryOptions = getGetSessionInfoQueryOptions(type, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const logoutV2 = (params, signal)=>{
    return client({
        url: `/auth/api/v2/logout`,
        method: 'GET',
        params,
        signal
    });
};
export const getLogoutV2QueryKey = (params)=>{
    return [
        `/auth/api/v2/logout`,
        ...params ? [
            params
        ] : []
    ];
};
export const getLogoutV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getLogoutV2QueryKey(params);
    const queryFn = ({ signal })=>logoutV2(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useLogoutV2(params, options) {
    const queryOptions = getLogoutV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getPostSponsorExemptionReasonResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.word.sample(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        matched: faker.datatype.boolean(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostOnboardingSponsorExemptionReasonResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.word.sample(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        matched: faker.datatype.boolean(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAddressOptionsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, ()=>faker.word.sample());
export const getPostParticipantAddressVerifyResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostAdvisorConnectResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        matched: faker.datatype.boolean(),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostAdvisorPasswordResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        matched: faker.datatype.boolean(),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostAdvisorVerifyResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        matched: faker.datatype.boolean(),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantCompanyOptionsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, ()=>faker.word.sample());
export const getPostParticipantCompanyVerifyResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantContactResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRegistrationContactResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        addressVerified: faker.datatype.boolean(),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        companyVerified: faker.datatype.boolean(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorVerifyResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.word.sample(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        matched: faker.datatype.boolean(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorAccessCodeRequestResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.word.sample(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        matched: faker.datatype.boolean(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantVerifyResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRegistrationStateResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        addressVerified: faker.datatype.boolean(),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        companyVerified: faker.datatype.boolean(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchRegistrationStateResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        addressVerified: faker.datatype.boolean(),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        companyVerified: faker.datatype.boolean(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBiometricLoginResponseMock = (overrideResponse = {})=>({
        authorizationUrl: faker.word.sample(),
        ...overrideResponse
    });
export const getPostLoginResponseMock = (overrideResponse = {})=>({
        authorizationUrl: faker.word.sample(),
        ...overrideResponse
    });
export const getPostEntityLoginResponseMock = (overrideResponse = {})=>({
        homeUrl: faker.word.sample(),
        token: {
            access_token: faker.word.sample(),
            expires_in: faker.number.int({
                min: undefined,
                max: undefined
            }),
            refresh_token: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            scope: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            token_type: faker.word.sample()
        },
        ...overrideResponse
    });
export const getGetLoginLogResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            browser: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            createdAt: faker.word.sample(),
            device: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ipAddress: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            os: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetMfaMethodsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: `${faker.date.past().toISOString().split('.')[0]}Z`,
            entryType: faker.word.sample(),
            isPrimary: faker.datatype.boolean(),
            mfaEntryId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            userId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            value: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getDeleteMfaEntryResponseMock = (overrideResponse = {})=>({
        createdAt: `${faker.date.past().toISOString().split('.')[0]}Z`,
        entryType: faker.word.sample(),
        isPrimary: faker.datatype.boolean(),
        mfaEntryId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        value: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPatchMfaIsPrimaryResponseMock = (overrideResponse = {})=>({
        createdAt: `${faker.date.past().toISOString().split('.')[0]}Z`,
        entryType: faker.word.sample(),
        isPrimary: faker.datatype.boolean(),
        mfaEntryId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        value: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetQrCodeResponseMock = (overrideResponse = {})=>({
        qrCode: faker.word.sample(),
        secret: faker.word.sample(),
        ...overrideResponse
    });
export const getPostMfaSendResponseMock = (overrideResponse = {})=>({
        code: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        template: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostMfaSetupResponseMock = (overrideResponse = {})=>({
        code: faker.word.sample(),
        entryType: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        template: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        ...overrideResponse
    });
export const getPostMfaSetupVerifyResponseMock = (overrideResponse = {})=>({
        template: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        token: faker.helpers.arrayElement([
            {
                access_token: faker.word.sample(),
                expires_in: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                refresh_token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                scope: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                token_type: faker.word.sample()
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPostMfaVerifyResponseMock = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            min: undefined,
            max: undefined
        }),
        refresh_token: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        scope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetJwksResponseMock = (overrideResponse = {})=>({
        keys: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                e: faker.word.sample(),
                kty: faker.word.sample(),
                n: faker.word.sample(),
                use: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetDiscoveryResponseMock = (overrideResponse = {})=>({
        authorization_endpoint: faker.word.sample(),
        claims_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        grant_types_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        id_token_signing_alg_values_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        introspection_endpoint: faker.word.sample(),
        issuer: faker.word.sample(),
        registration_endpoint: faker.word.sample(),
        response_modes_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        response_types_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        revocation_endpoint: faker.word.sample(),
        scopes_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        subject_types_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        token_endpoint: faker.word.sample(),
        token_endpoint_auth_methods_supported: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        userinfo_endpoint: faker.word.sample(),
        ...overrideResponse
    });
export const getPostAuthImpersonationResponseMock = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            min: undefined,
            max: undefined
        }),
        refresh_token: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        scope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getPostIntrospectResponseMock = (overrideResponse = {})=>({
        active: faker.datatype.boolean(),
        aud: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        client_id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        exp: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        iat: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        iss: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        jti: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        nbf: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        scope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sub: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        token_type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        username: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostPushedAuthorizationRequestResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            expires_in: faker.number.int({
                min: undefined,
                max: undefined
            }),
            request_uri: faker.word.sample()
        }));
export const getPostRevokeResponseMock = (overrideResponse = {})=>({
        client_id: faker.word.sample(),
        token: faker.word.sample(),
        token_type_hint: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'access_token',
                'refresh_token'
            ]),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostTokenResponseMock = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            min: undefined,
            max: undefined
        }),
        refresh_token: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        scope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetUserinfoResponseMock = (overrideResponse = {})=>({
        email: faker.word.sample(),
        hasMfaNudge: faker.datatype.boolean(),
        iat: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isLoginDisclosure: faker.datatype.boolean(),
        isMfaEnabled: faker.datatype.boolean(),
        isMfaVerified: faker.datatype.boolean(),
        iss: faker.word.sample(),
        loginMethod: faker.word.sample(),
        passwordVersion: faker.number.int({
            min: undefined,
            max: undefined
        }),
        pendingPasswordReset: faker.datatype.boolean(),
        redirectParams: {},
        scopes: faker.word.sample(),
        sessionId: faker.word.sample(),
        sub: faker.number.int({
            min: undefined,
            max: undefined
        }),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostForgotPasswordResponseMock = (overrideResponse = {})=>({
        link: faker.word.sample(),
        template: faker.helpers.arrayElement([
            {
                description: faker.word.sample(),
                message: {
                    attachments: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    templateData: {
                        passwordResetUrl: faker.word.sample()
                    },
                    templateName: faker.word.sample()
                },
                meta: {
                    emailInfo: {
                        definitionId: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    entityInfo: {
                        entityId: faker.word.sample()
                    },
                    initiatedBy: {
                        env: faker.word.sample(),
                        idType: faker.word.sample()
                    }
                },
                recipients: {
                    bccs: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    ccs: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    to: {
                        email: faker.word.sample(),
                        name: faker.word.sample()
                    }
                },
                sender: {}
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPutResetPasswordResponseMock = (overrideResponse = {})=>({
        session: {
            cookie: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            email: faker.word.sample(),
            hasMfaNudge: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isMfaEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isMfaVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPasswordVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            loginMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            pendingPasswordReset: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            postLoginPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            postPersonaPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            redirectParams: faker.helpers.arrayElement([
                {
                    entityId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    entityType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loanId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    postLoginPath: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    redirect: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    redirectTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ucid: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sessionId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            userId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        template: {
            description: faker.word.sample(),
            message: {
                attachments: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                templateData: {
                    passwordResetUrl: faker.word.sample()
                },
                templateName: faker.word.sample()
            },
            meta: {
                emailInfo: {
                    definitionId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                entityInfo: {
                    entityId: faker.word.sample()
                },
                initiatedBy: {
                    env: faker.word.sample(),
                    idType: faker.word.sample()
                }
            },
            recipients: {
                bccs: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                ccs: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                to: {
                    email: faker.word.sample(),
                    name: faker.word.sample()
                }
            },
            sender: {}
        },
        ...overrideResponse
    });
export const getPostVerifyPasswordResponseMock = (overrideResponse = {})=>({
        isValid: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetPersonasResponseMock = (overrideResponse = {})=>({
        advisors: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                advisorId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                commercialPlatformsCount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                company: faker.word.sample(),
                loginUrl: faker.word.sample(),
                name: faker.word.sample(),
                type: faker.word.sample(),
                whitelabelId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        count: faker.number.int({
            min: undefined,
            max: undefined
        }),
        giftors: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                company: faker.word.sample(),
                giftorId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                name: faker.word.sample(),
                planType: faker.word.sample(),
                type: faker.word.sample()
            })),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                company: faker.word.sample(),
                loginUrl: faker.word.sample(),
                name: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                planType: faker.word.sample(),
                type: faker.word.sample(),
                whitelabelId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        sponsors: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                company: faker.word.sample(),
                externalSponsorPlanId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                firmCompanyName: faker.word.sample(),
                loginUrl: faker.word.sample(),
                planType: faker.word.sample(),
                recordKeeperId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                sponsorId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                sponsorPlanId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                type: faker.word.sample(),
                whitelabelId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        stateSavers: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                company: faker.word.sample(),
                loginUrl: faker.word.sample(),
                name: faker.word.sample(),
                planName: faker.word.sample(),
                plansCount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                planType: faker.word.sample(),
                stateSaverId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                surpasId: faker.word.sample(),
                type: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPatchUserEmailResponseMock = (overrideResponse = {})=>({
        token: faker.word.sample(),
        ...overrideResponse
    });
export const getPostUserEmailChangeResponseMock = (overrideResponse = {})=>({
        code: faker.word.sample(),
        template: {},
        ...overrideResponse
    });
export const getGetUserPreferencesResponseMock = (overrideResponse = {})=>({
        languagePreference: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        userId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetSessionInfoResponseMock = (overrideResponse = {})=>({
        accessRoles: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    min: undefined,
                    max: undefined
                })),
            undefined
        ]),
        activationDate: faker.helpers.arrayElement([
            `${faker.date.past().toISOString().split('.')[0]}Z`,
            undefined
        ]),
        advisorId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        clientUrl: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        company: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        doingBusinessAs: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        domain: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        effectivePlanDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.word.sample(),
        employerIdentificationNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        entity: faker.helpers.arrayElement([
            {
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                type: faker.word.sample(),
                userId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        environment: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        externalSponsorPlanId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmCompanyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        giftContributorId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        giftorId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        hasMfaNudge: faker.datatype.boolean(),
        homeUrl: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isMfaEnabled: faker.datatype.boolean(),
        isMfaVerified: faker.datatype.boolean(),
        isOnboarded: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isPasswordVerified: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isPlanActive: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        loginMethod: faker.word.sample(),
        loginUrl: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        onboardingWizardCompletedAt: faker.helpers.arrayElement([
            `${faker.date.past().toISOString().split('.')[0]}Z`,
            undefined
        ]),
        participantId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        pendingPasswordReset: faker.datatype.boolean(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        postLoginPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        postPersonaPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        programId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        recordKeeperId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        recordKeeperName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        redirectParams: faker.helpers.arrayElement([
            {
                entityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                entityType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                loanId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                postLoginPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                redirect: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                redirectTo: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                ucid: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        sessionId: faker.word.sample(),
        sponsorId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        sponsorPlanId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        sponsorPlanName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlanStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlanType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        subDomain: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        whitelabelId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostSponsorExemptionConfirmationMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/exempt/confirmation', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostSponsorExemptionReasonMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/exempt/reason', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostSponsorExemptionReasonResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostOnboardingSponsorExemptionConfirmationMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/onboarding/exempt/confirmation', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostOnboardingSponsorExemptionReasonMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/onboarding/exempt/reason', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostOnboardingSponsorExemptionReasonResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAddressOptionsMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/register/address/options', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetParticipantAddressOptionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantAddressVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/address/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostParticipantAddressVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostAdvisorConnectMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/advisor/connect', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostAdvisorConnectResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostAdvisorPasswordMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/advisor/password', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostAdvisorPasswordResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostAdvisorVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/advisor/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostAdvisorVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantCompanyOptionsMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/register/company/options', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetParticipantCompanyOptionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantCompanyVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/company/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostParticipantCompanyVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantConnectVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/connect/verify', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPatchParticipantContactMockHandler = (overrideResponse)=>{
    return http.patch('*/auth/api/register/contact', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPatchParticipantContactResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRegistrationContactMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/contact', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostRegistrationContactResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/employer', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostSponsorVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorAccessCodeRequestMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/employer/access-code-request', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostSponsorAccessCodeRequestResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorConnectMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/employer/connect', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostSponsorPasswordMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/employer/password', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostParticipantPasswordMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/password', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostParticipantVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/register/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostParticipantVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRegistrationStateMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/registration/state', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetRegistrationStateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchRegistrationStateMockHandler = (overrideResponse)=>{
    return http.patch('*/auth/api/registration/state', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPatchRegistrationStateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBiometricLoginMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/bio-login', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostBiometricLoginResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/connect', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getDisableDeviceMockHandler = (overrideResponse)=>{
    return http.delete('*/auth/api/v1/device', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getListDevicesMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/device', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getRegisterDeviceMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/device/register', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPostGiftorUserSessionStartMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/giftor/user/session/start', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostLoginMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/login', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostLoginResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEntityLoginMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/login/entity', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostEntityLoginResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginLogMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/login/logs', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetLoginLogResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMfaMethodsMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/mfa/entries', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetMfaMethodsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteMfaEntryMockHandler = (overrideResponse)=>{
    return http.delete('*/auth/api/v1/mfa/entries/:mfaEntryId', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getDeleteMfaEntryResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchMfaIsPrimaryMockHandler = (overrideResponse)=>{
    return http.patch('*/auth/api/v1/mfa/is-primary/:mfaEntryId', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPatchMfaIsPrimaryResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQrCodeMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/mfa/qr-code', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetQrCodeResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMfaSendMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/mfa/send', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostMfaSendResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMfaSetupMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/mfa/setup', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostMfaSetupResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMfaSetupVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/mfa/setup/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostMfaSetupVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMfaVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/mfa/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostMfaVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetJwksMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/oidc/.well-known/jwks.json', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetJwksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDiscoveryMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/oidc/.well-known/openid-configuration', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetDiscoveryResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostAuthImpersonationMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/oidc/auth/impersonation', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostAuthImpersonationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostIntrospectMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/oidc/introspect', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostIntrospectResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPushedAuthorizationRequestMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/oidc/par', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostPushedAuthorizationRequestResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRevokeMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/oidc/revoke', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostRevokeResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostTokenMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/oidc/token', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostTokenResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserinfoMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/oidc/userinfo', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetUserinfoResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostForgotPasswordMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/password/forgot', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostForgotPasswordResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutResetPasswordMockHandler = (overrideResponse)=>{
    return http.put('*/auth/api/v1/password/reset', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPutResetPasswordResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostVerifyPasswordMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/password/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostVerifyPasswordResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPersonasMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/personas', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetPersonasResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnpaySsoMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/sso/onpay', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetOnpaySsoCallbackMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/sso/onpay/callback', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetOnpaySsoInitMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/sso/onpay/init', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetStateSaverUserSessionRefreshMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/state-saver/user/session/refresh', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostStateSaverUserSessionRefreshMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/state-saver/user/session/refresh', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetStateSaverUserSessionStartMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/state-saver/user/session/start', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPostStateSaverUserSessionStartMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/state-saver/user/session/start', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetStatusMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/status', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetPasswordStatusMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/status/password', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetEntityStatusMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/status/:entityType', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPatchUserEmailMockHandler = (overrideResponse)=>{
    return http.patch('*/auth/api/v1/user/email', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPatchUserEmailResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUserEmailChangeMockHandler = (overrideResponse)=>{
    return http.post('*/auth/api/v1/user/email', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getPostUserEmailChangeResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserPreferencesMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/user/preferences', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetUserPreferencesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUserPreferencesMockHandler = (overrideResponse)=>{
    return http.patch('*/auth/api/v1/user/preferences', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getGetSessionInfoMockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v1/user/session/:type', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse : getGetSessionInfoResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getLogoutV2MockHandler = (overrideResponse)=>{
    return http.get('*/auth/api/v2/logout', async (info)=>{
        await delay(1000);
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getSentinelHooksMock = ()=>[
        getPostSponsorExemptionConfirmationMockHandler(),
        getPostSponsorExemptionReasonMockHandler(),
        getPostOnboardingSponsorExemptionConfirmationMockHandler(),
        getPostOnboardingSponsorExemptionReasonMockHandler(),
        getGetParticipantAddressOptionsMockHandler(),
        getPostParticipantAddressVerifyMockHandler(),
        getPostAdvisorConnectMockHandler(),
        getPostAdvisorPasswordMockHandler(),
        getPostAdvisorVerifyMockHandler(),
        getGetParticipantCompanyOptionsMockHandler(),
        getPostParticipantCompanyVerifyMockHandler(),
        getPostParticipantConnectVerifyMockHandler(),
        getPatchParticipantContactMockHandler(),
        getPostRegistrationContactMockHandler(),
        getPostSponsorVerifyMockHandler(),
        getPostSponsorAccessCodeRequestMockHandler(),
        getPostSponsorConnectMockHandler(),
        getPostSponsorPasswordMockHandler(),
        getPostParticipantPasswordMockHandler(),
        getPostParticipantVerifyMockHandler(),
        getGetRegistrationStateMockHandler(),
        getPatchRegistrationStateMockHandler(),
        getPostBiometricLoginMockHandler(),
        getPostPayrollSetupMockHandler(),
        getDisableDeviceMockHandler(),
        getListDevicesMockHandler(),
        getRegisterDeviceMockHandler(),
        getPostGiftorUserSessionStartMockHandler(),
        getPostLoginMockHandler(),
        getPostEntityLoginMockHandler(),
        getGetLoginLogMockHandler(),
        getGetMfaMethodsMockHandler(),
        getDeleteMfaEntryMockHandler(),
        getPatchMfaIsPrimaryMockHandler(),
        getGetQrCodeMockHandler(),
        getPostMfaSendMockHandler(),
        getPostMfaSetupMockHandler(),
        getPostMfaSetupVerifyMockHandler(),
        getPostMfaVerifyMockHandler(),
        getGetJwksMockHandler(),
        getGetDiscoveryMockHandler(),
        getPostAuthImpersonationMockHandler(),
        getPostIntrospectMockHandler(),
        getPostPushedAuthorizationRequestMockHandler(),
        getPostRevokeMockHandler(),
        getPostTokenMockHandler(),
        getGetUserinfoMockHandler(),
        getPostForgotPasswordMockHandler(),
        getPutResetPasswordMockHandler(),
        getPostVerifyPasswordMockHandler(),
        getGetPersonasMockHandler(),
        getGetOnpaySsoMockHandler(),
        getGetOnpaySsoCallbackMockHandler(),
        getGetOnpaySsoInitMockHandler(),
        getGetStateSaverUserSessionRefreshMockHandler(),
        getPostStateSaverUserSessionRefreshMockHandler(),
        getGetStateSaverUserSessionStartMockHandler(),
        getPostStateSaverUserSessionStartMockHandler(),
        getGetStatusMockHandler(),
        getGetPasswordStatusMockHandler(),
        getGetEntityStatusMockHandler(),
        getPatchUserEmailMockHandler(),
        getPostUserEmailChangeMockHandler(),
        getGetUserPreferencesMockHandler(),
        getPatchUserPreferencesMockHandler(),
        getGetSessionInfoMockHandler(),
        getLogoutV2MockHandler()
    ];

//# sourceMappingURL=index.js.map